module.exports = __webpack_public_path__ + "img/help_upload_small.091c7f56.png";